module.exports = __webpack_public_path__ + "assets/images/slope-income/mobile.svg?v=d00065ff";